import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar } from "@air/primitive-avatar";
import { formatInitials } from "@air/utilities";
import { memo, useEffect } from "react";
import { useResizeDetector } from "react-resize-detector";
import { PublicSignUpButton } from "~/components/v2/components/board/PublicSignUpButton";
import { useKanbanOffsetContext } from "~/components/v2/components/shared/kanban/KanbanOffsetContextProvider";
import { useTableHeaderPositionContext } from "~/components/v2/components/shared/table/TableHeaderPositionContextProvider";
import { useAccountContext } from "~/providers/AccountProvider";
import { formatFullName } from "~/utils/formatFullName";
export const PublicBoardTopbar = /*#__PURE__*/ memo(()=>{
    const { data } = useAccountContext();
    const { lastName, firstName, email, avatar, id } = data || {};
    const initials = formatInitials(firstName, lastName);
    const { ref, height } = useResizeDetector({
        handleWidth: false
    });
    const { setTableHeaderTopPosition } = useTableHeaderPositionContext();
    const { setKanbanOffset } = useKanbanOffsetContext();
    useEffect(()=>{
        if (height) {
            setTableHeaderTopPosition(height);
            setKanbanOffset(height);
        }
    }, [
        height,
        setTableHeaderTopPosition,
        setKanbanOffset
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "sticky top-0 z-30 flex h-14 items-center justify-between bg-grey-1 px-4",
        ref: ref,
        children: [
            !!firstName && !!lastName && /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center gap-2",
                children: [
                    /*#__PURE__*/ _jsx(Avatar, {
                        colorSeed: id,
                        size: 24,
                        src: avatar,
                        text: initials
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "text-12 text-grey-11",
                        children: [
                            formatFullName(firstName, lastName),
                            " ",
                            /*#__PURE__*/ _jsx("span", {
                                className: "ml-1 text-12 text-grey-9",
                                children: email
                            })
                        ]
                    })
                ]
            }),
            !data && /*#__PURE__*/ _jsx(PublicSignUpButton, {})
        ]
    });
});
PublicBoardTopbar.displayName = "PublicBoardTopbar";
